import Ajax from '@/lib/ajax_wrapper'

import Pagination from '@/components/Pagination'

export default {
  props: {
    per_page: {
      default: 10,
      validatior: function(value) {
        return parseInt(value) > 0
      }
    },

    page_number: {
      default: 1,
      validatior: function(value) {
        return parseInt(value) > 0
      }
    }
  },

  components: {
    Pagination
  },

  data() {
    return {
      pageData: {}
    }
  },

  computed: {
    pagination() {
      return Ajax.page(this.page_number, this.per_page)
    }
  },

  methods: {
    changePage(pagination) {
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {page_number: pagination.page, per_page: pagination.page_size}
      })
    }
  }
}
